module.exports = __webpack_public_path__ + "img/28b)(Ritz Carlton Hotel)Montage von über 380 Zimmer und Suiten.jpg";